import { Box, TextInput } from '@labrav/react-components'
import React, { useMemo } from 'react'

import { useStyles } from './Reseller.styles'
import { KeyValue } from '../../../modules/privateOffer/privateOfferCreation/types'
import { ResellerInfo } from '../../../admin/modules/resaleAuthorizations'
import { useSelector } from '../../../store'
import { Autocomplete } from '@mui/material'
import { isEmpty } from 'lodash'

import { TextField } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { getRandom } from '@labrav/common'
import type { RootState } from '../../../store/types'

export type Reseller = {
  resellersInfo: ResellerInfo
  error: Record<string, string>
  handleUpdatedArray: (
    index: number,
    key: string,
    type?: string | undefined
  ) => (data: KeyValue) => void
  handleChange: (data: KeyValue) => void
}
export const Reseller: React.FC<Reseller> = ({
  handleChange,
  handleUpdatedArray,
  resellersInfo,
  error,
}) => {
  const { classes } = useStyles()
  const resellers = useSelector((state: RootState) => state.resellers.resellers)
  const randomKey = useMemo(
    () => getRandom(),
    [resellersInfo?.labraPlatformResellerId]
  )
  const handleResellerUpdate = (
    _: React.SyntheticEvent,
    value: ResellerInfo | null
  ) => {
    handleChange({
      key: 'resellersInfo',
      value: [
        {
          labraPlatformResellerId: value?.labraPlatformResellerId || '',
          resellerAwsAccountId: value?.resellerAwsAccountId || '',
          resellerCompanyName: value?.resellerCompanyName || '',
        },
      ],
    })
  }
  const handleAwsAccountUpdate = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleUpdatedArray(
      0,
      'resellersInfo'
    )({
      key: 'resellerAwsAccountId',
      value: event.target.value,
    })
  }
  return (
    <Box heading={'Reseller details'} subHeading={''}>
      <div
        className={classes.container}
        key={`labraPlatformResellerId-${randomKey}`}
      >
        <Autocomplete
          popupIcon={
            <KeyboardArrowDownIcon
              fontSize="small"
              data-testid="arrow-button"
            />
          }
          id="labraPlatformResellerId"
          className={classes.root}
          data-testid="reseller"
          onChange={handleResellerUpdate}
          defaultValue={resellersInfo}
          isOptionEqualToValue={(option: ResellerInfo, value: ResellerInfo) =>
            option.labraPlatformResellerId === value.labraPlatformResellerId
          }
          getOptionLabel={(option: ResellerInfo) =>
            option?.resellerCompanyName || ''
          }
          options={resellers}
          renderOption={(
            _props,
            option: {
              resellerCompanyName?: string
              labraPlatformResellerId?: string
            },
            { ...getOptionProps }
          ) => {
            return (
              <li
                {..._props}
                className={_props.className}
                {...getOptionProps}
                key={`option-${option?.resellerCompanyName}-${_props.id}`}
                style={{ fontSize: '12px' }}
                data-testid={`option-${option?.labraPlatformResellerId}`}
              >
                <div>{option?.resellerCompanyName}</div>
              </li>
            )
          }}
          filterOptions={(options: any[], state: any) => {
            const filteredOptions = options.filter(option =>
              option.resellerCompanyName
                .toLowerCase()
                .includes(state?.inputValue?.toLowerCase())
            )
            return filteredOptions
          }}
          renderInput={params => (
            <TextField
              {...params}
              label="AWS reseller"
              variant="standard"
              required={true}
              className={classes.textField}
              error={!isEmpty(error?.labraPlatformResellerId)}
              helperText={error?.labraPlatformResellerId}
              slotProps={{
                input: {
                  ...params.InputProps,
                },

                htmlInput: {
                  ...params.inputProps,
                  'data-testid': 'reseller-name',
                },
              }}
            />
          )}
        />
        <div
          className={classes.buyerFieldContainer}
          key={`resellerAwsAccountId-${randomKey}`}
        >
          <TextInput
            keyName="resellerAwsAccountId"
            title="Reseller AWS account ID"
            type="number"
            placeHolder=""
            value={resellersInfo?.resellerAwsAccountId || ''}
            isError={!isEmpty(error?.resellerAwsAccountId)}
            onChange={handleAwsAccountUpdate}
            isReadOnly={false}
            isRequired={true}
            errorText={error?.resellerAwsAccountId}
            variant="regularV2"
            showSpinner={false}
          />
        </div>
      </div>
    </Box>
  )
}
